// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import {
  LogoAndTextFormValues,
  TextFormValues,
} from '../../../../../containers/EmbroideryService/types'
import { ColorSelector, TextEmbroideryColorKey } from '../../selectors/ColorSelector'
import { EmbroideryOptionWrapper } from '../../shared-form-styles'

interface Props {
  form:
    | Pick<FormikContextType<TextFormValues>, 'touched' | 'setFieldValue' | 'errors' | 'values'>
    | Pick<
        FormikContextType<LogoAndTextFormValues>,
        'touched' | 'setFieldValue' | 'errors' | 'values'
      >
  textColors: TextEmbroideryColorKey[] | null
}

export const NameColor: FC<Props> = ({ form, textColors }) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const handleSelectColor = (colorName: string) => form.setFieldValue('textColor', colorName)

  if (!textColors) return null
  return (
    <EmbroideryOptionWrapper>
      <ColorSelector
        errorMessage={form.touched.textColor ? form.errors.textColor : undefined}
        onSelectColor={handleSelectColor}
        selectedColorKey={form.values.textColor}
        label={fixtures.textOption.textColorLabel}
        colorNames={textColors}
      />
    </EmbroideryOptionWrapper>
  )
}
